<template>
  <div class="cashflow-loader">
    <div class="header-text"> מתחילים לצמוח! המערכת בונה לך את התזרים הראשון שלך</div>
    <div class="image-container">
      <div class="first-row">
        <img class="pyramid-image" :src="require('@/assets/onboarding/cashflow-loader/pyramid.svg')">
        <img class="arrows-image" :src="require('@/assets/onboarding/cashflow-loader/arrows.svg')">
      </div>
      <img class="wave-image" :src="require('@/assets/onboarding/cashflow-loader/wave.svg')">
      <div class="sky">
        <img class="sun-image" :src="require('@/assets/onboarding/cashflow-loader/sun.svg')">
      </div>
    </div>
  </div>
</template>
<script>
import router from '../../../../../../router';
import Segment from '../../../../../../Segment';

export default {
  async created() {
    Segment.trackUserGot('CashflowLoaderEntered');
    setTimeout(() => router.push({ path: '/home' }), 5000);
  },
  name: 'CashflowLoader',
};
</script>

<style lang="scss" scoped>

@import '../../../../../../../node_modules/base-ui/src/scss/riseup-colors';
@import '../../../../../../scss/mixins';

.cashflow-loader {
  height: 100%;
  @include white-page-frame;

  .header-text {
    @include responsive-padding;
    @include responsive-padding-top-bottom;
    font-size: 22px;
    font-weight: bold;
    line-height: 1.27;
  }

  .image-container {
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;

    .first-row {
      height: 102px;
      width: 100%;
      display: flex;

      .arrows-image {
        width: 100%;
      }
    }

    .sky {
      background: #FE9D16;
      height: 100%;
      display: flex;
      .sun-image {
        align-self: flex-end;
        width: 100%;
      }
    }
  }
}

</style>
